import { useMileStoneHeaderSectionQuery } from 'generated/graphql';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  description: string;
}

export function useQuery(milestoneId: string) {
  const tuple = useMileStoneHeaderSectionQuery({
    variables: {
      id: milestoneId
    },
    skip: milestoneId === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.milestone?.id ?? '',
        description: tuple.data?.milestone?.description ?? '',
        title: tuple.data?.milestone?.title ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
